module.exports = __webpack_public_path__ + "static/media/select-injection-site-with-text.2c5a1547.svg";